import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "profile", "reportItem", "emptyState" ]

  connect() {
    this.filter()
  }

  filter() {
    if (!this.hasProfileTarget) return

    const selectedProfileSlug = this.profileTarget.value
    let visibleCount = 0

    this.reportItemTargets.forEach((item) => {
      const belongsToSelectedProfile = item.dataset.profileSlug === selectedProfileSlug
      item.classList.toggle("hidden", !belongsToSelectedProfile)

      const checkbox = item.querySelector('input[type="checkbox"]')
      if (checkbox) {
        checkbox.disabled = !belongsToSelectedProfile
        if (!belongsToSelectedProfile) checkbox.checked = false
      }

      if (belongsToSelectedProfile) visibleCount += 1
    })

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.toggle("hidden", visibleCount > 0)
    }
  }
}
